import { render, staticRenderFns } from "./index.vue?vue&type=template&id=240c33eb"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TemplatesPagesDescription: require('/home/ticketshoplv/public_html/ticketshop.lt/components/templates/pages/description.vue').default,TemplatesPagesGroup: require('/home/ticketshoplv/public_html/ticketshop.lt/components/templates/pages/group.vue').default,TemplatesPagesHome: require('/home/ticketshoplv/public_html/ticketshop.lt/components/templates/pages/home.vue').default})
